import { VariableType } from 'json-to-graphql-query';

export const TokensVariables = {
  tokens: 'TokensInput'
};

export const TokensArgs = {
  tokens: new VariableType('tokens')
};
